import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

type AttachmentConfig = {
  allowed_extensions: string[];
  not_allowed_extensions: string[];
  limited_size: number;
};

const useAttachmentConfig = (): {
  attachment: AttachmentConfig | undefined;
} => {
  const [attachment, setAttachment] = useState<AttachmentConfig | undefined>(
    undefined,
  );
  const { generalConfig } = useSelector((state: RootState) => state.configReducer);

  useEffect(() => {
    setAttachment(generalConfig?.attachmentsConfig);
  }, [generalConfig?.attachmentsConfig]);

  return useMemo(() => ({ attachment }), [attachment]);
};

export { useAttachmentConfig };
